export function map(value, in_min, in_max, out_min, out_max) {
    let val = (value - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
    // if (val < out_min) val = out_min;
    // else if (val > out_max) val = out_max;
    return val;
}